import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    january: {
        id: '_.date_input.january',
        defaultMessage: 'January'
    },
    february: {
        id: '_.date_input.february',
        defaultMessage: 'February'
    },
    march: {
        id: '_.date_input.march',
        defaultMessage: 'March'
    },
    april: {
        id: '_.date_input.april',
        defaultMessage: 'April'
    },
    may: {
        id: '_.date_input.may',
        defaultMessage: 'May'
    },
    june: {
        id: '_.date_input.june',
        defaultMessage: 'June'
    },
    july: {
        id: '_.date_input.july',
        defaultMessage: 'July'
    },
    august: {
        id: '_.date_input.august',
        defaultMessage: 'August'
    },
    september: {
        id: '_.date_input.september',
        defaultMessage: 'September'
    },
    october: {
        id: '_.date_input.october',
        defaultMessage: 'October'
    },
    november: {
        id: '_.date_input.november',
        defaultMessage: 'November'
    },
    december: {
        id: '_.date_input.december',
        defaultMessage: 'December'
    }
});
